import {
  SET_TOPICS,
  ADD_TOPIC,
  DELETE_TOPIC,
  TOPICS_ERROR,
  SELECT_TOPIC,
  CLEAR_SELECTED,
  UPDATE_TOPIC,
  SET_CUSTOMER_TOPICS,
  APPEND_CUSTOMER_TOPICS,
  REMOVE_CUSTOMER_TOPIC,
  PREPEND_CUSTOMER_TOPICS
} from '../actionTypes';

const initialState = {
  list: [],
  error: null,
  loaded: false,
  selected: null,
  customerTopics: [],
  customerHasMore: false,
  customerPage: 1
};

export default function conversationTopicsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOPICS:
      return { ...state, list: action.payload, loaded: true, error: null };

    case ADD_TOPIC:
      return { ...state, list: [action.payload, ...state.list] };

    case DELETE_TOPIC:
      return { ...state, list: state.list.filter((t) => t.id !== action.payload) };

    case TOPICS_ERROR:
      return { ...state, error: action.payload };

    case SELECT_TOPIC:
      return { ...state, selected: action.payload };

    case CLEAR_SELECTED:
      return { ...state, selected: null };

    case UPDATE_TOPIC:
      return {
        ...state,
        list: state.list.map((t) => (t.id === action.payload.id ? action.payload : t))
      };

    case SET_CUSTOMER_TOPICS:
      return {
        ...state,
        customerTopics: action.payload.topics,
        customerHasMore: action.payload.hasMore,
        customerPage: action.payload.page
      };

    case APPEND_CUSTOMER_TOPICS:
      return {
        ...state,
        customerTopics: [...state.customerTopics, ...action.payload.topics],
        customerHasMore: action.payload.hasMore,
        customerPage: action.payload.page
      };

    case PREPEND_CUSTOMER_TOPICS:
      return {
        ...state,
        customerTopics: [action.payload, ...state.customerTopics]
      };

    case REMOVE_CUSTOMER_TOPIC:
      return {
        ...state,
        customerTopics: state.customerTopics.filter(t => t.id !== action.payload),
      };

    default:
      return state;
  }
}
